import React from "react";

import { Preview } from "@creatomate/preview";
import { Button, Icon } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans } from "app/utils";
import general from "constants/general";

import createElement from "components/stories/video-studio/utils/creatomate/createElement";
import { usePreviewTime } from "components/stories/video-studio/contexts/TimeContext";
import { getEffectColorsByOrg, getOrganizationDefaultFonts } from "components/stories/video-studio/utils";

interface AddTextProps {
  onSelectedEffect: (value: string) => void;
  preview: Preview;
}

const AddText: React.FC<AddTextProps> = ({ onSelectedEffect, preview }) => {
  const { time } = usePreviewTime();

  const { profile: { organization } } = useProfile();

  const handleAddText = async () => {
    let duration;
    const organizationFont = getOrganizationDefaultFonts(organization.name || "");
    const effectColors = getEffectColorsByOrg("None", organization.name || "");
    onSelectedEffect(general.DEFAULT_EFFECT);

    if (time + 5 <= (preview.state?.duration || 0)) {
      duration = 5;
    }

    await createElement({
      duration,
      type: "text",
      text: "New text element",
      time: Math.round((time + Number.EPSILON) * 100) / 100,
      dynamic: true,
      width: "20%",
      height: "20%",
      x_alignment: "50%",
      y_alignment: "50%",
      ...organizationFont,
      ...effectColors
    }, preview);
  };

  return (
    <Button inverted onClick={handleAddText}>
      <Icon icon="ios-plus" /><Trans>Add Text</Trans>
    </Button>
  );
};

export default AddText;
